<template>
  <div>
    <vue-editor v-model="localValue"
                :editorToolbar="customToolbar"
                :editorOptions="editorSettings">
    </vue-editor>
  </div>
</template>

<script>
  import {VueEditor, Quill} from 'vue2-editor'
  import ImageUpload from './QuillImageUpload'
  import ImageDrop from './QuillImageDrop'
  import ImageResize from 'quill-image-resize-module'

  Quill.register('modules/imageUpload', ImageUpload)
  Quill.register('modules/imageDrop', ImageDrop)
  Quill.register('modules/imageResize', ImageResize)

  const icons = Quill.import('ui/icons')
  icons['header']['2'] = '<svg viewBox="0 0 576 512">' +
    '<path fill="currentColor" d="M0 139.131V44c0-6.627 5.373-12 12-12h296c6.627 0 12 5.373 12 12v95.131c0 6.627-5.373 12-12 12h-26.747c-6.627 0-12-5.373-12-12V80h-82.015v352H236c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H84c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h48.762V80H50.125v59.131c0 6.627-5.373 12-12 12H12c-6.627 0-12-5.372-12-12zM423.276 35.759l-67.994 72.001c-7.16 7.581-1.863 20.24 8.724 20.24H408v256h-43.993c-10.58 0-15.89 12.652-8.724 20.24l67.993 72.001c4.735 5.014 12.716 5.01 17.448 0l67.994-72.001c7.16-7.581 1.863-20.24-8.724-20.24H456V128h43.993c10.58 0 15.89-12.652 8.724-20.24l-67.993-72.001c-4.735-5.014-12.716-5.01-17.448 0z">' +
    '</path>' +
    '</svg>'

  icons['clean'] = '<svg viewBox="0 0 384 512">' +
    '<path fill="currentColor" d="M372 32H159.529C72.194 32 .245 102.216.001 189.551-.243 276.877 70.729 348 158 348v120c0 6.627 5.373 12 12 12h12c6.627 0 12-5.373 12-12V68h60v400c0 6.627 5.373 12 12 12h12c6.627 0 12-5.373 12-12V68h82c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12zM158 312c-67.271 0-122-54.729-122-122S90.729 68 158 68v244z" class="">' +
    '</path>' +
    '</svg>'

  export default {
    name: 'o-vue-editor',
    props: {
      value: {},
      content_images: {
        type: Array
      },
      id: {
        default: null
      },
      isImage: {
        default: false
      },
      uploadUrl: {
        default: '/api/save-image'
      },
      imagePath: {
        default: '/images/'
      }
    },
    data() {
      return {
        localValue: '',
        customToolbar: [
          [{'header': 2}],
          ['clean'],
          ['bold', 'italic'],
          [{list: 'ordered'}, {list: 'bullet'}],
          [{'indent': '-1'}, {'indent': '+1'}],
          ['link']
        ],
        editorSettings: {
          modules: {
            imageDrop: {
              uploadImage: {
                url: this.uploadUrl,
                method: 'POST',
                headers: {'id': this.id},
                callbackOK: (serverResponse, next) => {
                  if (this.id === null) {
                    this.content_images.push(serverResponse)
                    next(this.imagePath + '/tmp/' + serverResponse);
                  } else {
                    next(this.imagePath + '/' + this.id + '/' + serverResponse);
                  }
                },
                callbackKO: (serverError) => {
                  console.log(serverError)
                }
              }
            },
            imageResize: {},
            imageUpload: {
              url: this.uploadUrl,
              method: 'POST',
              headers: {'id': this.id},
              callbackOK: (serverResponse, next) => {
                if (this.id === null) {
                  this.content_images.push(serverResponse)
                  next(this.imagePath + '/tmp/' + serverResponse);
                } else {
                  next(this.imagePath + '/' + this.id + '/' + serverResponse);
                }
              },
              callbackKO: serverError => {
                console.log(serverError)
              },
            }
          }
        }
      }
    },
    methods: {
      setValue(val) {
        this.localValue = val
      }
    },

    components: {
      VueEditor
    },
    watch: {
      value(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.setValue(newVal)
        }
      },
      localValue(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.$emit('input', newVal)
        }
      }
    },
    mounted() {
      var val = this.value
      this.setValue(val)
    },
    created () {
      if (this.isImage) {
        this.customToolbar[this.customToolbar.length - 1].push('image')
      }
    }
  }
</script>
